import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfilePreferenceBannerComponent } from './profile-preference-banner.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
  declarations: [ProfilePreferenceBannerComponent],
  imports: [
    CommonModule,
    I18nModule,
    BrowserModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SanofiNewSMSAlertBannerComponent: {
          component: ProfilePreferenceBannerComponent
        },
      },
    } as CmsConfig),
  ],
  providers: [
  ],
})
export class ProfilePreferenceBannerModule { }
